<template>
    <div class="type">
        <div class="heads">审核状态</div>
        <div class="main">
            <div class="lists" @click="btn_item(index)" :class="index==select_index?'active':''" v-for="(item,index) in list" :key="index">{{item}}</div>
        </div>
    </div>
</template>


<script>
export default {
    data(){
        return {
            list:['全部','待审核','审核退回','审核通过'],
            select_index:0
        }
    },
    methods:{
        btn_item(index){
            this.select_index=index;
        }
    }
}
</script>

<style lang="scss" scoped>
.type{
    text-align: left;
    width: 100%;
    height:100vh ;
    background-color: #fff;
    padding:20px 30px;
    box-sizing: border-box;
    .heads{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #222222;
        padding-top:20px;
    }
    .main{
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap:wrap;
        align-items: center;
        margin-top:20px;
        .lists{
            width: 210px;
            height: 60px;
            background: #E3F1FC;
            border: 1px solid #E3F1FC;
            border-radius: 10px;
            line-height: 60px;
            text-align: center;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-bottom:20px;
        }
        .active{
            border: 1px solid #2590EB;
            background: #fff;
            color:#2590EB;
        }
    }
}
</style>